// The vehicle import's preview, the same as the vendor import's (owner,
// 2026-10-20): every vehicle the Apply touches, in `ImportChangeList`'s groups
// — added, then edited. A row is the vehicle number over its year, make and
// model. A vehicle the file leaves out is not a change — an import never
// touches it (`domain/fleetImport.ts`) — so it is not listed.

import { FLEET_FIELD_LABEL, type VehicleImportPreview } from '../api/types'
import { countedHeading } from '../lib/format'
import { ImportChangeList, type ChangeRow } from './ImportChangeList'

export function VehicleImportChanges({ preview }: { preview: VehicleImportPreview }) {
  const added: ChangeRow[] = preview.adds.map((a) => {
    const status = a.values.status
    const described = [a.values.year, a.values.make, a.values.model].filter(Boolean).join(' ')
    return {
      key: `add-${a.row}`,
      title: a.values.number ? `#${a.values.number}` : `Row ${a.row}`,
      subtitle: described || null,
      lines: [{ note: status && status !== 'In Service' ? `New vehicle, added as ${status}` : 'New vehicle' }],
    }
  })
  const edited: ChangeRow[] = preview.updates.map((u) => ({
    key: u.vehicle_id,
    title: `#${u.number}`,
    lines: u.changes.map((c) => ({ label: FLEET_FIELD_LABEL[c.field], before: c.before, after: c.after })),
  }))

  return (
    <ImportChangeList
      empty="Nothing in this file changes the vehicle list."
      groups={[
        { heading: countedHeading(added.length, 'Vehicle', 'Added'), rows: added },
        { heading: countedHeading(edited.length, 'Vehicle', 'Edited'), rows: edited },
      ]}
    />
  )
}
